export default "__VITE_ASSET__a84359ee__"